configureRouter.$inject = ["$stateProvider"];export function configureRouter($stateProvider) {
  "ngInject";

  function funnelTemplateProvider(stateName) {
    templateProvider.$inject = ['$templateFactory', 'Funnel'];
    function templateProvider($templateFactory, Funnel) {
      var url = Funnel.getTemplateUrl(stateName);
      console.log('url is: ' + url);
      return $templateFactory.fromUrl(url);
    }

    return templateProvider;
  }

  $stateProvider

  /**
                  * GLOBAL APP STATES
                  */.

  state('gplans', {
    abstract: true,
    component: 'gplansApp' }).


  state('gplans.userConsole.**', {
    url: '/',
    views: {
      $default: {
        component: 'gplansMainLayout' } },


    lazyLoad: function lazyLoad($transition$) {
      var $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
      var $state = $transition$.injector().get('$state');
      var GUARDS = $transition$.injector().get('GUARDS');
      var NavigationStack = $transition$.injector().get('NavigationStack');

      return GUARDS.isAuthorized(true).
      catch(function (err) {
        NavigationStack.push({
          url: $transition$.router.urlService.url() });

        $state.go('gplans.auth.login');
        throw err;
      }).
      then(function () {return import('./user-console/user-console.module' /* webpackChunkName: "user-console.module" */);}).
      then(function (_ref) {var userConsoleModule = _ref.userConsoleModule;return $ocLazyLoad.load(userConsoleModule);}).
      catch(function (err) {
        console.warn('lazy load fail: user-console.module', err);
        throw err;
      });

    } })


  // .state('gplans.survey.**', {
  //   url: '/survey-new',
  //   views: {
  //     $default: {
  //       component: 'surveyLayout'
  //     }
  //   },
  //   lazyLoad: ($transition$) => {
  //     const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
  //     const $state = $transition$.injector().get('$state');
  //     const GUARDS = $transition$.injector().get('GUARDS');
  //     const NavigationStack = $transition$.injector().get('NavigationStack');
  //
  //     return import('./survey/survey.module.js'/* webpackChunkName: "survey.module" */ )
  //       .then(({surveyModule}) => $ocLazyLoad.load(surveyModule))
  //       .catch(err => {
  //         console.warn('lazy load fail: survey.module', err);
  //         throw err;
  //       })
  //
  //   }
  // })
  .
  state('gplans.palette', {
    url: '/palette',
    views: {
      $default: {
        component: 'uiPalette' } },


    lazyLoad: function lazyLoad($transition$) {
      var $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
      return import('./ui/components/palette/palette.component' /* webpackChunkName: "palette.component" */).
      then(function (_ref2) {var PaletteComponent = _ref2.PaletteComponent;
        var moduleToUpdate = angular.module('gplans.ui').
        component('uiPalette', PaletteComponent);
        return $ocLazyLoad.load(moduleToUpdate);
      }).
      catch(function (err) {
        console.warn('lazy load fail: palette.component', err);
        throw err;
      });
    } }).










  state('survey', {
    url: "/survey/:surveyId",
    abstract: true,
    controller: 'SurveyController',
    templateUrl: 'templates/layout/base.html' }).

  state('base', {
    url: "",
    abstract: true,
    controller: 'BaseController',
    templateUrl: 'templates/layout/base.html',
    resolve: {
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }] } }).


  state('funnel', {
    url: "",
    abstract: true,
    controller: 'FunnelController',
    templateUrl: 'templates/layout/base.html' }).

  state('base.select_meta', {
    url: "/survey/select",
    controller: 'SelectMetaController',
    controllerAs: 'vm',
    title: 'Select',
    //templateUrl: 'templates/survey/select-meta.html',
    templateProvider: ["$templateFactory", "$rootScope", function templateProvider($templateFactory, $rootScope) {
      var url = !$rootScope.offerId ?
      'templates/survey/selectDefault.html' :
      'templates/survey/select-meta.html';
      console.log('url is: ' + url);
      return $templateFactory.fromUrl(url);
    }] }).

  state('base.survey_name', {
    url: "/survey/name",
    controller: 'SurveyNameController',
    controllerAs: 'vm',
    title: 'Put Your Name',
    templateUrl: 'templates/survey/name.html' }).

  state('base.start_quiz_and_run', {
    url: "/survey/start-quiz",
    controller: 'QuizStartAndRunController',
    controllerAs: 'vm' }).

  state('base.blood_type', {
    url: "/survey/blood-type",
    controller: 'BloodTypeController',
    controllerAs: 'vm',
    title: 'Blood Type',
    //templateUrl: 'templates/survey/blood-type.html',
    resolve: {
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }] },

    templateProvider: ["$templateFactory", "$rootScope", function templateProvider($templateFactory, $rootScope) {
      var url = !$rootScope.offerId ?
      'templates/survey/blood-typeDefault.html' :
      'templates/survey/blood-type.html';
      console.log('url is: ' + url);
      return $templateFactory.fromUrl(url);
    }] }).

  state('base.blood_type_complete', {
    url: "/survey/blood-type/:metabolicTypeId",
    authenticated: true,
    controller: 'BloodTypeCompleteController',
    controllerAs: 'vm',
    title: 'Blood Type Complete',
    // templateUrl: 'templates/survey/complete.html'
    templateProvider: funnelTemplateProvider('base.blood_type_complete'),
    resolve: {
      affilate: ["$http", "gplansConf", function affilate($http, gplansConf) {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/affilate/',
          method: "GET" }).
        then(function (res) {
          return res.data;
        });
        return req;
      }] } }).


  state('base.survey_start', {
    url: "/survey/start",
    controller: 'SurveyStartController',
    controllerAs: 'vm',
    title: 'Survey',
    templateUrl: 'templates/survey/start.html',
    resolve: {
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }] } }).


  state('base.completeByOfferId', {
    url: "/survey/completeByOfferId/:offerId",
    authenticated: true,
    controller: 'SurveyCompleteByOfferIdController',
    controllerAs: 'vm' }).

  state('base.complete', {
    url: "/survey/complete/:userSurvey",
    authenticated: true,
    controller: 'SurveyCompleteController',
    controllerAs: 'vm',
    title: 'Survey Complete',
    templateProvider: funnelTemplateProvider('base.complete'),
    resolve: {
      plansResolved: ["$http", "gplansConf", function plansResolved($http, gplansConf) {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/plans/',
          method: "GET" });

        return req;
      }],
      uid: ["AuthenticationNew", function uid(AuthenticationNew) {
        return AuthenticationNew.getUID();
      }],
      affilate: ["$http", "gplansConf", function affilate($http, gplansConf) {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/affilate/',
          method: "GET" }).
        then(function (res) {
          return res.data;
        });
        return req;
      }],
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }],
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.calculate', {
    url: "/survey/calculate/:userSurvey",
    controller: 'SurveyCalculateController',
    controllerAs: 'vm',
    title: 'Calculating',
    //templateUrl: 'templates/survey/calculate.html',
    resolve: {
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] },

    templateProvider: ["$templateFactory", "$rootScope", function templateProvider($templateFactory, $rootScope) {
      var url = !$rootScope.offerId ?
      'templates/survey/calculateDefault.html' :
      'templates/survey/calculate.html';
      console.log('url is: ' + url);
      return $templateFactory.fromUrl(url);
    }] }).

  state('funnel.register_after_quiz', {
    url: "/get-results",
    controller: 'RegisterAfterQuizController',
    controllerAs: 'vm',
    title: 'Get results',
    //templateUrl: 'templates/authentication/registerAfterQuiz.html',
    templateProvider: ["$templateFactory", "$rootScope", function templateProvider($templateFactory, $rootScope) {
      var url = !$rootScope.offerId ?
      'templates/authentication/registerAfterQuizDefault.html' :
      'templates/authentication/registerAfterQuiz.html';
      console.log('url is: ' + url);
      return $templateFactory.fromUrl(url);
    }],
    resolve: {
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('comeback', {
    url: "/b/:url",
    controller: 'ComebackController',
    controllerAs: 'vm' }).

  state('comeback-retargeting', {
    url: "/retarget",
    controller: 'ComebackRetargetController',
    controllerAs: 'vm' }).

  state('survey.weight_age_form', {
    url: "/final-step",
    controller: 'WeightAgeFormController',
    controllerAs: 'vm',
    title: 'Final step',
    //templateUrl: 'templates/survey/weight_age_form.html',
    resolve: {
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] },

    templateProvider: ["$templateFactory", "$rootScope", function templateProvider($templateFactory, $rootScope) {
      var url = !$rootScope.offerId ?
      'templates/survey/weight_age_formDefault.html' :
      'templates/survey/weight_age_form.html';
      console.log('url is: ' + url);
      return $templateFactory.fromUrl(url);
    }] }).

  state('survey.question', {
    url: "/question/:question",
    controller: 'QuestionController',
    controllerAs: 'vm',
    title: 'Survey',
    authenticated: true,
    templateUrl: 'templates/survey/question.html',
    resolve: {
      User: ["AuthenticationNew", "$q", function User(AuthenticationNew, $q) {
        return AuthenticationNew.getAuthenticatedAccount().catch(function (err) {
          console.log(err);
          return $q(function (resolve, reject) {
            resolve(undefined);
          });
        });
      }],
      Survey: ["$http", "$stateParams", "gplansConf", function Survey($http, $stateParams, gplansConf) {
        // todo: move to Survey Service
        return $http.get(gplansConf.API_URL + '/api/v1/surveys/' + $stateParams.surveyId + '/').
        then(function (res) {
          return res.data;
        });
      }] },

    lazyLoad: function lazyLoad($transition$) {
      var $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
      var $state = $transition$.injector().get('$state');
      var GUARDS = $transition$.injector().get('GUARDS');
      var NavigationStack = $transition$.injector().get('NavigationStack');
      var $rootScope = $transition$.injector().get('$rootScope');
      var $location = $transition$.injector().get('$location');

      return GUARDS.isAuthorized().
      catch(function (err) {
        NavigationStack.push({
          url: $transition$.router.urlService.url() });

        $rootScope.redirectTo = $location.path();
        $state.go('gplans.auth.login');
        throw err;
      }).
      then(function () {return import('./user-console/user-console.module' /* webpackChunkName: "user-console.module" */);}).
      then(function (_ref3) {var userConsoleModule = _ref3.userConsoleModule;return $ocLazyLoad.load(userConsoleModule);}).
      catch(function (err) {
        console.warn('lazy load fail: user-console.module', err);
        throw err;
      });

    }
    //templateProvider: funnelTemplateProvider('survey.question'),
  }).
  state('base.store', {
    url: "/store/checkout",
    authenticated: true,
    controller: 'StoreController',
    controllerAs: 'vm',
    title: 'Store',
    templateProvider: funnelTemplateProvider('base.store'),
    resolve: {
      plansResolved: ["$http", "gplansConf", function plansResolved($http, gplansConf) {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/plans/',
          method: "GET" });

        return req;
      }],
      uid: ["AuthenticationNew", function uid(AuthenticationNew) {
        return AuthenticationNew.getUID();
      }],
      affilate: ["$http", "gplansConf", function affilate($http, gplansConf) {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/affilate/',
          method: "GET" }).
        then(function (res) {
          return res.data;
        });
        return req;
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }],
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_payment', {
    url: "/store/plan/:plan/payment",
    authenticated: true,
    controller: 'PaymentController',
    controllerAs: 'vm',
    title: 'Payment',
    // templateUrl: 'templates/store/payment.html',
    templateProvider: funnelTemplateProvider('base.store_payment'),
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_payment_before_quiz', {
    url: "/store/plan/payment_straight_sale",
    controller: 'PaymentBeforeQuizController',
    controllerAs: 'vm',
    title: 'Payment',
    templateUrl: 'templates/store/payment-before-quiz.html',
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.amazon_temp', {
    url: "/amazon",
    controller: 'AmazonTempController',
    controllerAs: 'vm',
    title: 'Payment',
    templateUrl: 'templates/store/amazon-temp.html',
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_payment_after_retargeting', {
    url: "/store/plan/payment_retargeted",
    authenticated: true,
    controller: 'PaymentController',
    controllerAs: 'vm',
    title: 'Payment',
    templateUrl: 'templates/store/payment-retarget.html',
    // templateProvider: function ($templateFactory, $rootScope) {
    //   var url = $rootScope.offerId ?
    //     'templates/store/payment' + $rootScope.offerId + '.html' :
    //     'templates/store/payment.html';
    //   console.log('url is: ' + url);
    //   return $templateFactory.fromUrl(url);
    // }
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_payment_take10', {
    url: "/store/plan/payment_take10",
    authenticated: true,
    controller: 'PaymentController',
    controllerAs: 'vm',
    title: 'Payment',
    templateUrl: 'templates/store/payment-take10.html',
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_upsell', {
    url: "/store/plan/:plan/upsell/",
    authenticated: true,
    controller: 'UpsellController',
    controllerAs: 'vm',
    title: 'Upsell',
    // templateUrl: 'templates/store/upsell.html',
    templateProvider: funnelTemplateProvider('base.store_upsell'),
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_upsell_next', {
    url: "/store/plan/upsell2/",
    authenticated: true,
    controller: 'UpsellController',
    controllerAs: 'vm',
    title: 'Upsell',
    //templateUrl: 'templates/store/upsell-bundle.html',
    templateProvider: funnelTemplateProvider('base.store_upsell_next'),
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_downsell', {
    url: "/store/plan/downsell/",
    authenticated: true,
    controller: 'UpsellController',
    controllerAs: 'vm',
    title: 'Upsell',
    templateProvider: funnelTemplateProvider('base.store_downsell'),
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_account_info', {
    url: "/store/plan/:plan/account",
    authenticated: true,
    controller: 'AccountInfoController',
    controllerAs: 'vm',
    title: 'Account Info',
    templateUrl: 'templates/store/accountinfo.html',
    resolve: {
      affilate: ["$http", "gplansConf", function affilate($http, gplansConf) {
        var req = $http({
          url: gplansConf.API_URL + '/api/v1/affilate/',
          method: "GET" }).
        then(function (res) {
          return res.data;
        });
        return req;
      }],
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_upsell_nutritionist', {
    url: "/store/plan/upsell_nutritionist/",
    authenticated: true,
    controller: 'UpsellController',
    controllerAs: 'vm',
    title: 'Upsell',
    //templateUrl: 'templates/store/upsell-nutritionist.html',
    templateProvider: funnelTemplateProvider('base.store_upsell_nutritionist'),
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_downsell_nutritionist', {
    url: "/store/plan/downsell_nutritionist/",
    authenticated: true,
    controller: 'UpsellController',
    controllerAs: 'vm',
    title: 'Upsell',
    //templateUrl: 'templates/store/upsell-down-nutritionist.html',
    templateProvider: funnelTemplateProvider('base.store_downsell_nutritionist'),
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('cleanup', {
    url: "/restart",
    controller: ['gplansConf', function (gplansConf) {
      localStorage.clear();
      window.location.assign(gplansConf.APP_BASE_URL + 'login');
    }] }).

  state('base.store_one_time_payment', {
    url: "/store/one-time-payment/",
    authenticated: true,
    controller: 'OneTimePaymentController',
    controllerAs: 'vm',
    title: 'Payment',
    templateUrl: 'templates/store/one-time-payment.html' }).

  state('base.store_shopify_upsell', {
    url: "/store/upsell-products/",
    authenticated: true,
    controller: 'ShopifyUpsellController',
    controllerAs: 'vm',
    title: 'Products',
    templateUrl: 'templates/store/upsell-supplements-shopify.html',
    resolve: {
      currency: ["MeasurementSystem", function currency(MeasurementSystem) {
        return MeasurementSystem.getCurrency().then(
        function (res) {
          return res;
        });
      }],
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('upsell_mp_tip', {
    url: "/upsell_mp/?{tip:int}&{id:int}",
    authenticated: true,
    controller: 'UpsellMpTipController',
    controllerAs: 'vm',
    title: 'Upsell Managed Plans',
    templateUrl: 'templates/tips/upsell-mp-tip.html',
    params: {
      tip: {
        squash: true,
        value: 0 },

      id: {
        squash: true,
        value: 0 } },


    resolve: {
      currency: function currency() {
        return 'USD';
      },
      mesSystem: ["MeasurementSystem", function mesSystem(MeasurementSystem) {
        return MeasurementSystem.getMeasurementSystem().then(
        function (res) {
          return res;
        });
      }] } }).


  state('base.store_resub_form', {
    url: "/update-payment-details/:uid",
    authenticated: false,
    controller: 'UpdatePaymentController',
    controllerAs: 'vm',
    title: 'Update Payment Details',
    templateUrl: 'templates/store/update-payments.html' }).

  state('base.cancellation', {
    url: "/cancellation",
    authenticated: true,
    controller: 'CancellationController',
    controllerAs: 'vm',
    title: 'Cancellation',
    templateUrl: 'templates/store/cancellation.html',
    lazyLoad: function lazyLoad($transition$) {
      var $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
      var $state = $transition$.injector().get('$state');
      var GUARDS = $transition$.injector().get('GUARDS');
      var NavigationStack = $transition$.injector().get('NavigationStack');
      var $rootScope = $transition$.injector().get('$rootScope');
      var $location = $transition$.injector().get('$location');

      return GUARDS.isAuthorized().
      catch(function (err) {
        NavigationStack.push({
          url: $transition$.router.urlService.url() });

        $rootScope.redirectTo = $location.path();
        $state.go('gplans.auth.login');
        throw err;
      }).
      then(function () {return import('./user-console/user-console.module' /* webpackChunkName: "user-console.module" */);}).
      then(function (_ref4) {var userConsoleModule = _ref4.userConsoleModule;return $ocLazyLoad.load(userConsoleModule);}).
      catch(function (err) {
        console.warn('lazy load fail: user-console.module', err);
        throw err;
      });

    } }).

  state('gplans.notFound', {
    url: '*notFoundPath',
    params: { notFoundPath: { value: '/any-path', squash: true } },
    views: {
      $default: {
        template: '<h1>404 - not found</h1>' } },


    onEnter: ["$stateParams", function onEnter($stateParams) {
      "ngInject";
      console.warn('not found', $stateParams.notFoundPath);
    }] });


}